import type { Option } from "@tento-lona/sheets";
import { Div } from "@tento-ui/component-builtin";
import { $qs } from "@tento-ui/dom-selectors";
import { Tracing } from "@tento-core/tracing";
import { QuestionIcon, LonaIcons } from "@tento-ui/ui/icons";
import { Typography } from "@tento-ui/ui/typography";
import { SheetLegend } from "@tento-lona/sheets-ui/sheet/sheet-legend.ts";
import {
  type BindCellContext,
  type RenderPlugin,
  RowOptionsElement,
  type SheetLegendClass,
} from "@tento-lona/sheets-ui/sheet/render-plugin.ts";
import { type SheetRow } from "@tento-lona";
import type { SheetDelegate } from "@tento-lona/sheets-ui/sheet/sheet-delegate.ts";

/**
 * The source-row plugin used for a source row whose type no other plugin
 * claims.
 */
export class FallbackSourcePlugin implements RenderPlugin.SourceRow<
  HTMLDivElement,
  SheetLegend.DefaultRow
> {
  readonly role = "source";
  readonly id = "fallback";
  readonly icon: HTMLTemplateElement = LonaIcons.$template(QuestionIcon);

  constructor(readonly makeRowOptions: RowOptionsElement.Factory) {}

  optionsInfo(_row: SheetRow.Joined.Handle): Option<string> {
    return "Fallback plugin for unsupported row types. This plugin is used when no specific plugin is available for the row type.";
  }

  makeCell(): HTMLDivElement {
    const $c = Div.make();
    const $t = Typography.p("Unknown Plugin");
    $t.classList.add("label");
    $c.appendChild($t);
    $c.assignStyles({
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      textAlign: "start",
      height: "100%",
      paddingInline: "8px",
      color: "var(--red)",
    });
    return $c;
  }

  bindCell($cell: HTMLDivElement, context: BindCellContext): void {
    const { descriptor, lookupKey } = context.row;
    Tracing.warn("ui")(
      `unknown row type "${descriptor.id}" (role=${descriptor.role}, ` +
        `lookupKey=${lookupKey ?? "—"}) — no render plugin registered`,
    );
    $qs(".label", $cell).textContent = `Unknown Plugin: "${descriptor.id}"`;
  }

  onResize(_$cell: HTMLDivElement, _context: BindCellContext): void {}

  loadData = null;
  legendFactory: Option<SheetLegendClass<SheetLegend.DefaultRow>> = null;

  onBindRow(_sheet: SheetDelegate, _row: SheetRow.Joined.Handle): void {}
  onViewportColumnsChanged(): void {}
  onRenderedColumnsWillChange(): void {}
}
